// extracted by mini-css-extract-plugin
module.exports = {"content":"e2ff468f85--content--FXLQ0","footer":"e2ff468f85--footer--nDTyi","error":"e2ff468f85--error--BFQmL"};